import Globalstyle from "./Globalstyle";

export default Globalstyle;